


import Base from './Base';

export default class Poi extends Base {
  schema = {
    poi_uid: String,
    poi_type: String,
    info: {
      poi_id: Number,
      region: Number,
      city: Number,
      cn_name: String,
      en_name: String,
      lat: Number,
      lng: Number,
      address: String,
      grade: Number,
      desc: String,
      pic: {
        full: String,
        big: String,
        small_s: String
      },
      stay_agv: Number,
      stay_min: Number,
      stay_max: Number,
      tags: Array,
      average_prices: Array,
      store_link: String // 门店专有详情页页面
    }
  };

  static parseInput(obj = {}) {
    // let info = obj.info;
    return {
      ...obj
      // wiki_url: info.wiki_url ? info.wiki_url.url : undefined,
      // tags: info.tags || [],
      // average_prices: info.average_prices || []
    };
  }

  // city.getListByRegionId()
  static parseInput2(obj) {
    return {
      uid: obj.poi_uid,
      cn_name: obj.cn_name,
      en_name: obj.en_name
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/Poi.js